import React, { useState, useEffect } from "react";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";

import MenuItem from "@mui/material/MenuItem";
import { Get_limited_Choose_Fields_From_MongoDB } from "../../api/Get_limited_Choose_Fields_From_MongoDB";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_And_Regex_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_And_Regex_With_Sort";
import getNestedPropBySearchProp from "../../../functions/getNestedPropBySearchProp";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { StaffuseAuth } from "../../security/StaffuseAuth";

function SearchAgenciesSetECs({ handleChoose, Attendee }) {
  const { logout } = StaffuseAuth();

  //Get Agencies
  const [Agencies, setAgencies] = useState([]);
  useEffect(() => {
    Get_limited_Choose_Fields_From_MongoDB(
      "IP",
      "Agencies",
      20,
      setAgencies,
      {
        "BasicInfo.Name": 1,
        "BasicInfo.Country": 1,
        "MetaData.IP_id": 1,
        _id: 1,
      },
      logout
    );
  }, []);

  //Get ECs
  const [ECs, setECs] = useState([]);
  useEffect(() => {
    let Arr_AgenciiesIDs = Agencies.map((Agency) => Agency._id);
    Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
      "IP",
      "EC",
      { "MetaData.Agency_id": { $in: Arr_AgenciiesIDs } },
      100,
      setECs,
      { "BasicInfo.First_Name": 1 },
      {
        "BasicInfo.First_Name": 1,
        "BasicInfo.Last_Name": 1,
        "MetaData.Agency_id": 1,
        _id: 1,
      },
      logout
    );
  }, [Agencies]);

  const [KnownEC, setKnownEC] = useState({});
  const [KnownAgency, setKnownAgency] = useState({});
  useEffect(() => {
    if (
      Attendee.IPInfo &&
      Attendee.IPInfo.EC_ID &&
      Attendee.IPInfo.EC_ID.length > 0
    ) {
      Get_One_From_MongoDB(
        "IP",
        "EC",
        Attendee.IPInfo.EC_ID,
        setKnownEC,
        logout
      );
    }
  }, [Attendee?.IPInfo?.EC_ID]);
  useEffect(() => {
    if (KnownEC.MetaData && KnownEC.MetaData.Agency_id) {
      Get_One_From_MongoDB(
        "IP",
        "Agencies",
        KnownEC.MetaData.Agency_id,
        setKnownAgency,
        logout
      );
    }
  }, [KnownEC]);

  //add KnownEC to the array of ECs
  if (KnownEC && KnownEC._id && !ECs.find((EC) => EC._id === KnownEC._id)) {
    setECs([...ECs, KnownEC]);
  }
  //add KnownAgency to the array of Agencies
  if (
    KnownAgency &&
    KnownAgency._id &&
    !Agencies.find((Agency) => Agency._id === KnownAgency._id)
  ) {
    setAgencies([...Agencies, KnownAgency]);
  }

  const [SearchAgency, setSearchAgency] = useState("");
  const handleChangeSearchAgency = (e) => {
    setSearchAgency(e.target.value);
  };

  function handleSubmitSearchAgency(e) {
    e.preventDefault();
    if (SearchAgency && SearchAgency.length > 0) {
      Get_limited_Choose_Fields_From_MongoDB_With_Search_And_Regex_With_Sort(
        "IP",
        "Agencies",
        {},
        [{ Field: "BasicInfo.Name", Value: SearchAgency }],
        20,
        setAgencies,
        { "BasicInfo.Name": 1 },
        {
          "BasicInfo.Name": 1,
          "BasicInfo.Country": 1,
          "MetaData.IP_id": 1,
          _id: 1,
        },
        logout
      );
    }
  }

  return (
    <>
      <Grid item xs={4}>
        <TextField
          key="SearchAgency"
          name="SearchAgency"
          label="Search Agency"
          variant="outlined"
          margin="normal"
          fullWidth
          value={SearchAgency}
          onChange={(e) => handleChangeSearchAgency(e)}
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
        />{" "}
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => handleSubmitSearchAgency(e)}
        >
          Search Agency
        </Button>
        <TextField
          label="EC_ID"
          name="EC_ID"
          variant="outlined"
          margin="normal"
          value={
            Attendee.IPInfo && Attendee.IPInfo["EC_ID"]
              ? Attendee.IPInfo["EC_ID"]
              : ""
          }
          onChange={handleChoose}
          fullWidth
          sx={{ marginBottom: "10px" }}
          select
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
        >
          <MenuItem key={""} value={""}>
            NULL
          </MenuItem>
          {ECs.map((EC) => (
            <MenuItem key={EC._id} value={EC._id}>
              {EC.BasicInfo
                ? EC.BasicInfo.First_Name +
                  " " +
                  EC.BasicInfo.Last_Name +
                  " @ " +
                  getNestedPropBySearchProp(
                    Agencies,
                    "_id",
                    EC.MetaData.Agency_id,
                    "Name",
                    "BasicInfo"
                  ) +
                  " , " +
                  getNestedPropBySearchProp(
                    Agencies,
                    "_id",
                    EC.MetaData.Agency_id,
                    "Country",
                    "BasicInfo"
                  )
                : "---"}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label="EC_ID"
          name="EC_ID"
          variant="outlined"
          margin="normal"
          value={
            Attendee.IPInfo && Attendee.IPInfo["EC_ID"]
              ? Attendee.IPInfo["EC_ID"]
              : ""
          }
          onChange={handleChoose}
          fullWidth
          sx={{ marginBottom: "10px" }}
          select
          InputProps={{
            style: {
              backgroundColor: "white",
            },
          }}
          disabled={true}
        >
          <MenuItem key={""} value={""}>
            NULL
          </MenuItem>
          {ECs.map((EC) => (
            <MenuItem key={EC._id} value={EC._id}>
              {EC._id}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </>
  );
}

export default SearchAgenciesSetECs;
